/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useEffect, useState } from "react";
import { Loading } from "./AllReports";
import { deviceType } from "../../utils/helpers";
import { useHistory } from "react-router-dom";
import { eventNotifierService } from "./eventNotifier";

const MissedAndDueTable = ({ data, initialLoad, activeTab }) => {
  let history = useHistory();

  const viewDetail = (id) => {
    const returnTab = activeTab === "dues" ? "due" : "missed";
    localStorage.setItem("master-location", `/reports3/${returnTab}?return=true`);
    history.push(`/patients3/${id}`);
  };

  useEffect(() => {
    disableSortValues();
    setSwitchSortStatus(null);
    setSwitchSortName(null);
    setSwitchSortDeviceManufacturer(null);
  }, [activeTab]);

  const [sortDisableStatus, setSortDisableStatus] = useState(true);
  const [sortDisableName, setSortDisableName] = useState(true);
  const [sortDisableDeviceManufacturer, setSortDisableDeviceManufacturer] = useState(true);

  const [switchSortStatus, setSwitchSortStatus] = useState(null);
  const [switchSortName, setSwitchSortName] = useState(null);
  const [switchSortDeviceManufacturer, setSwitchSortDeviceManufacturer] = useState(null);

  const [sortUpAndDown, setSortUpAndDown] = useState("headerSortUp");

  const disableSortValues = () => {
    setSortDisableStatus(true);
    setSortDisableName(true);
    setSortDisableDeviceManufacturer(true);
  };

  const toggleUpAndDown = (toggleEvent) => {
    if (toggleEvent) {
      setSortUpAndDown("headerSortDown");
    } else {
      setSortUpAndDown("headerSortUp");
    }
  };
  const callEventNotifier = (name, value, tab) => {
    eventNotifierService.sortEvent({ columnName: name, columnValue: value, activeTab: tab });
  };

  const handleSort = (key) => {
    disableSortValues();
    setSwitchSortStatus(null);
    setSwitchSortName(null);
    setSwitchSortDeviceManufacturer(null);
    switch (key) {
      case "status":
        if (switchSortStatus == null) {
          setSortDisableStatus(false);
          setSwitchSortStatus(true);
          toggleUpAndDown(switchSortStatus);
          callEventNotifier("status", "asc", activeTab);
        } else if (switchSortStatus) {
          setSortDisableStatus(false);
          setSwitchSortStatus(false);
          toggleUpAndDown(switchSortStatus);
          callEventNotifier("status", "desc", activeTab);
        } else {
          setSwitchSortStatus(null);
          callEventNotifier(null, null, activeTab);
        }
        break;
      case "name":
        if (switchSortName == null) {
          setSortDisableName(false);
          setSwitchSortName(true);
          toggleUpAndDown(switchSortName);
          callEventNotifier("name", "asc", activeTab);
        } else if (switchSortName) {
          setSortDisableName(false);
          setSwitchSortName(false);
          toggleUpAndDown(switchSortName);
          callEventNotifier("name", "desc", activeTab);
        } else {
          setSwitchSortName(null);
          callEventNotifier(null, null, activeTab);
        }
        break;
      case "manufacturer":
        if (switchSortDeviceManufacturer == null) {
          setSortDisableDeviceManufacturer(false);
          setSwitchSortDeviceManufacturer(true);
          toggleUpAndDown(switchSortDeviceManufacturer);
          callEventNotifier("manufacturer", "asc", activeTab);
        } else if (switchSortDeviceManufacturer) {
          setSortDisableDeviceManufacturer(false);
          setSwitchSortDeviceManufacturer(false);
          toggleUpAndDown(switchSortDeviceManufacturer);
          callEventNotifier("manufacturer", "desc", activeTab);
        } else {
          setSwitchSortDeviceManufacturer(null);
          callEventNotifier(null, null, activeTab);
        }
        break;
    }
  };

  return (
    <div className="contentTbl">
      <table className="overview" id="data-table">
        <thead>
          <tr>
            <th className={sortDisableStatus ? "sortDisable" : sortUpAndDown}>
              <a href="#" id="status-header" onClick={() => handleSort("status")}>
                Status
              </a>
            </th>
            <th className={sortDisableName ? "sortDisable" : sortUpAndDown}>
              <a href="#" id="name-header" onClick={() => handleSort("name")}>
                Last Name, First Name
              </a>
            </th>
            <th className={sortDisableDeviceManufacturer ? "sortDisable" : sortUpAndDown}>
              <a href="#" id="device-manuf-header" onClick={() => handleSort("manufacturer")}>
                Device Manufacturer
              </a>
            </th>
            <th>Device Type</th>
            <th>Billing Cycle</th>
            <th>Phone</th>
            <th>Last PE Note</th>
            <th>Days Left</th>
            <th></th>
          </tr>
        </thead>
        {initialLoad ? (
          <Loading colspan="18" />
        ) : data.length > 0 ? (
          <tbody>
            {!sortDisableStatus || !sortDisableName || !sortDisableDeviceManufacturer
              ? data.map((item, index) => (
                  <tr key={index}>
                    <td>{`${activeTab === "missed" ? "Missed" : "Due"} on: ${new Date(
                      item?.missedDate
                    ).toLocaleDateString()}`}</td>
                    <td>{`${item?.lastName}, ${item?.firstName}`}</td>
                    <td>{item?.deviceMFR}</td>
                    <td>{deviceType(item?.deviceType)}</td>
                    <td>{item?.billingCycle === "THIRTYDAY" ? "30 Days" : "90 Days"}</td>
                    <td>
                      {item?.phoneNumber}
                      <br />
                      {item?.mobilePhoneNumber}
                    </td>
                    <td style={{ width: "20%" }}>{item?.note}</td>
                    <td>{item?.daysRemaining}</td>
                    <td>
                      <div id={`view-btn-${index}`} className="show-options">
                        <a
                          id="viewEditBtnId"
                          onClick={() => viewDetail(item?.patientId)}
                          className="btn btnTeal"
                        >
                          View/Edit
                        </a>
                      </div>
                    </td>
                  </tr>
                ))
              : data
                  .sort((a, b) => a.daysRemaining - b.daysRemaining)
                  .map((item, index) => (
                    <tr key={index}>
                      <td>{`${activeTab === "missed" ? "Missed" : "Due"} on: ${new Date(
                        item?.missedDate
                      ).toLocaleDateString()}`}</td>
                      <td>{`${item?.lastName}, ${item?.firstName}`}</td>
                      <td>{item?.deviceMFR}</td>
                      <td>{deviceType(item?.deviceType)}</td>
                      <td>{item?.billingCycle === "THIRTYDAY" ? "30 Days" : "90 Days"}</td>
                      <td>
                        {item?.phoneNumber}
                        <br />
                        {item?.mobilePhoneNumber}
                      </td>
                      <td style={{ width: "20%" }}>{item?.note}</td>
                      <td>{item?.daysRemaining}</td>
                      <td>
                        <div id={`view-btn-${index}`} className="show-options">
                          <a
                            id="viewEditBtnId"
                            onClick={() => viewDetail(item?.patientId)}
                            className="btn btnTeal"
                          >
                            View/Edit
                          </a>
                        </div>
                      </td>
                    </tr>
                  ))}
          </tbody>
        ) : null}
      </table>
      {data.length === 0 && !initialLoad && (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 300,
            fontSize: 18,
          }}
        >
          No patients
        </div>
      )}
    </div>
  );
};

export default MissedAndDueTable;
